export const prepend = (value, array) => {
  const newArray = array.slice()
  newArray.unshift(value)
  return newArray
}

export default prepend
